import { CSSObject } from '@emotion/serialize';
import { Component as ComponentContainer } from '@styles/layout';
import { TextComponent } from '@model/content';
import { TextMarkdown } from '@components/common/description';
import { americanize } from '@util/string';

export const TextContainer = ({ value, alignment }: TextComponent) => {
  const textAlign = alignment && americanize(alignment);

  return (
    <ComponentContainer>
      <TextMarkdown description={value} styles={textAlign ? ({ textAlign } as CSSObject) : undefined} />
    </ComponentContainer>
  );
};
